import SAVE_OPTIN from './saveOptIn.gql';

export default SAVE_OPTIN;
export { SAVE_OPTIN };
